<script>
	import ItemSelector from 'components/item-selector';

	export default {
		props: {
			grades: {
				type: Array,
				required: true
			},
			onGradeClick: {
				type: Function,
				default: function () {}
			},
			prekView: {
				type: Boolean,
				default: false
			},
			grid: {
				type: Boolean,
				default: false
			},
			legend: {
				type: String
			}
		},
		components: {
			'item-selector': ItemSelector
		},
		methods: {
			getSizeClass(g) {
				if (this.prekView) {
					if (g.id === 192000) {
						return 'span-3';
					}
					return '';
				}

				if (g.text.match(/\d+-\d+/)) {
					return 'span-1-5';
				}

				return '';
			}
		},
		computed: {
			items() {
				return this.grades.map(g => ({
					...g,
					class: this.getSizeClass(g)
				}));
			}
		}
	};
</script>
<template>
	<item-selector
		class="grade-selector"
		:items="items"
		:grid="grid"
		:legend="legend"
		:on-item-click="onGradeClick"></item-selector>
</template>
